import { useState, useEffect } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../../@/components/ui/dialog";
import { Button } from "../../@/components/ui/button";
import { Textarea } from "../../@/components/ui/textarea";

export default function AddNoteDialog({ open, onOpenChange, studentName, initialNote = "", onSave }) {
    const [note, setNote] = useState(initialNote);

    useEffect(() => {
        setNote(initialNote);
    }, [initialNote, open]);

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="h-auto w-[calc(100vw-2rem)] max-w-md rounded-lg">
                <DialogHeader>
                    <DialogTitle className="font-heading text-[1.2rem]">Add Note for {studentName}</DialogTitle>
                    
                </DialogHeader>
                <div className="text-base font-body mb-2">
                        Add any relevant notes or comments about this student's attendance
                    </div>
                <Textarea
                    placeholder="Enter note"
                    value={note}
                    onChange={e => setNote(e.target.value)}
                    className=" mb-6 w-full min-h-20 rounded-md border border-(--neutral-300) px-3 py-2 font-body resize-y focus:outline-none focus:ring-2 focus:ring-primary"
                />
                <DialogFooter className="flex flex-col-reverse gap-2 sm:flex-row sm:justify-between">
                    <Button variant="outline" className="" onClick={() => onOpenChange(false)}>
                        Cancel
                    </Button>
                    <Button
                        variant=""
                        className=""
                        onClick={() => {
                            onSave(note);
                            onOpenChange(false);
                        }}
                        // disabled={note.trim() === ""}
                    >
                        Save Note
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    )
}